import { useReducer, useEffect } from 'react'
import { detailProps } from './components/accountdetail'
import { AnyAction } from 'redux'
import { getSupplierId, getUserId, resetObj } from '../../tools/util'
import { history } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import { setModuleDataAction } from '../../modules/pagecache'
import {
  GET_EMPUSERLIST,
  DEL_USER,
  ADMIN_TRANSFER,
} from '../../api/System_Api'
import { userRouter } from '../../route'
import { CustomerConfirm } from '../../components/ModalUser'

// action 类型定义
const ACCOUNT_ACTION_TYPE = {
  GET_DATA: 'ACCOUNT/GET_Data', // 获取数据
  SET_DATA: 'ACCOUNT/SET_Data', // 设置数据
  SET_ROLE: 'ACCOUNT/SET_Role', // 设置角色数据
  SEARCH_DATA: 'ACCOUNT/Search_Data', // 搜索数据
  CHANGE_PAGES: 'ACCOUNT/Change_Pages', // 分页
  LOADING: 'ACCOUNT/Loading', // loading
  SET_DETAILDATA: 'ACCOUNT/SET_Detail_Data', // 设置详情
  SET_ENABLE: 'ACCOUNT/SET_Enable', // 禁启用账号
  VISIBLE: 'ACCOUNT/SET_Visible', // 弹窗显示隐藏
  ROLE_VISIBLE: 'ACCOUNT/SET_Role_Visible', // role 弹窗显示隐藏
  ADD_VISIBLE: 'ACCOUNT/SET_Add_Visible', // 新增弹窗显示隐藏
  CHANGE_USERID: 'ACCOUNT/Change_Userid', //
  CHANGE_DATA: 'ACCOUNT/CHANGE_DATA', // 替换所有状态
  SET_CHEACKDATA: 'ACCOUNT/SET_CHEACKDATA',
  CHANGE_ROLE: 'ACCOUNT/Change_Role', // 选择角色
  IS_UPDATE: 'ACCOUNT/IS_UPDATE', // 跳转新增或编辑页面
  SET_EMP: 'ACCOUNT/SET_EMP',
}
// 当前状态接口
interface AccountState {
  dataSource: { data: any[]; total: number; loading: boolean }
  detaildata: detailProps
  visible: boolean // 弹窗
  rolevisible: boolean // role弹窗
  addvisible: boolean // 新增角色弹窗
  searchdata: any
  pages: {
    pageNo: number
    pagesize: number
  }
  checkData: {
    key: any[]
    data: any[]
  }
  selectUserId: string //  选中的userid
  roleList: any[]
  role: any
  isUpdate: boolean
  empId: string
}
// 默认数据
const defaultState: AccountState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 员工账号详情数据
  detaildata: {
    name: '', // 姓名
    moblie: '', // 手机号码
    code: '', // 员工编号
    job: '', // 岗位
    organization: '', // 所属组织
    department: '', // 所属部门
    role: '', // 授权角色
  },
  // 初始化弹窗
  visible: false,
  rolevisible: false,
  addvisible: false,
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pagesize: 30,
  },
  checkData: {
    key: [],
    data: [],
  },
  selectUserId: '',
  roleList: [],
  role: {},
  isUpdate: false,
  empId: '',
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case ACCOUNT_ACTION_TYPE.GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pagesize = 30
      arr.searchdata = resetObj(arr.searchdata)
      return arr
    case ACCOUNT_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case ACCOUNT_ACTION_TYPE.SET_DETAILDATA:
      arr.detaildata = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.VISIBLE:
      arr.visible = !arr.visible
      return arr
    case ACCOUNT_ACTION_TYPE.SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_PAGES:
      arr.pages = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.LOADING:
      arr.dataSource.loading = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_USERID:
      arr.selectUserId = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.ROLE_VISIBLE:
      arr.rolevisible = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.ADD_VISIBLE:
      arr.addvisible = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_CHEACKDATA:
      arr.checkData.data = action.value.data
      arr.checkData.key = action.value.key
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_ROLE:
      arr.role = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_ROLE:
      arr.roleList = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.IS_UPDATE:
      arr.isUpdate = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_EMP:
      arr.empId = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: ACCOUNT_ACTION_TYPE.SET_DATA,
  value: param,
})
// 弹窗显示隐藏
const changevisibleAction = () => ({
  type: ACCOUNT_ACTION_TYPE.VISIBLE,
})

// role弹窗显示隐藏
const changerolevisibleAction = (param: boolean) => ({
  type: ACCOUNT_ACTION_TYPE.ROLE_VISIBLE,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pagesize?: number }) => ({
  type: ACCOUNT_ACTION_TYPE.CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: ACCOUNT_ACTION_TYPE.LOADING,
  value: param,
})

const changeroleAction = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.CHANGE_ROLE,
  value: param,
})
// 设置批量的值
const setCheackData = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.SET_CHEACKDATA,
  value: param,
})

const useAccountHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, visible, pages, rolevisible, checkData, role } = state
  const supRoute = userRouter[1].url

  const dispatchredux = useDispatch()
  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取列表数据
  const getdata = async (accountState: AccountState) => {
    // 在saga处理中 获取state
    const params = { ...accountState.pages, ...accountState.searchdata }
    // 添加loading
    dispatch(changeloadingAction(true))
    const data = await GET_EMPUSERLIST({
      pageNo: params.pageNo,
      pageSize: params.pagesize,
      supplierId: getSupplierId(),
      name: params.realName,
      mail: params.mail,
      mobile: params.mobile,
      schemeId: params.schemeId,
    })
    if (data.code === 0) {
      const resdata = data.data.content
      const count = data.data.totalCount
      const action = setdataAction({
        dataSource: { data: resdata, total: count, loading: false },
        pageNo: data.data.pageNo,
      })
      dispatch(action)
    }
  }

  // 搜索
  const onSearch = (params: any) => {
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 分页
  const onChange = (pageNo: number, pagesize?: number) => {
    const action = changepageAction({
      pageNo: pageNo,
    })
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pagesize: pagesize ? pagesize : 30,
        },
      },
    })
  }

  // 关闭显示弹窗
  const visiblemodal = () => {
    const action = changevisibleAction()
    dispatch(action)
  }

  // 删除用户
  const deleteuser = () => {
    if (checkData.key.length === 0) {
      message.warning('请先勾选数据，再提交')
      return
    }
    CustomerConfirm({
      title: '提示',
      content: '确认删除？',
      onOk: () => postDeleteUser(),
    })
  }

  const postDeleteUser = async () => {
    message.loading('删除账号中', 0)
    const userList = checkData.key
    const data = await DEL_USER({
      params: userList,
    })
    if (data.code === 0) {
      message.success('删除成功')
      getdata(state)
    }
  }
  const rolevisiblemodal = () => {
    dispatch(changerolevisibleAction(false))
  }

  // 勾选数据
  const onChangeCheck = (key: any, info: any) => {
    const action = setCheackData({ data: info, key: key })
    dispatch(action)
  }

  // 选择角色
  const onChangeRole = (key: any) => {
    dispatch(changeroleAction(key))
  }

  // 跳转新增页面
  const addMember = () => {
    history.push({
      pathname: supRoute + '/accoutadd',
    })
  }

  // 移交管理员
  const moveAdmin = async () => {
    if (checkData.key.length === 0) {
      message.warn('请先勾选账号')
      return
    }
    if (checkData.key.length > 1) {
      // message.warn(`请先勾选一个账号`);
      dispatch(changerolevisibleAction(true))
      return
    }
    visiblemodal()
  }
  // 确认移交管理员
  const confirmMoveAdmin = async () => {
    const data = await ADMIN_TRANSFER({
      id: checkData.key.join(),
      supplierUserId: getUserId(),
    })
    if (data.code === 0) {
      message.success('操作成功!')
      getdata(state)
    } else {
      message.warning(`${data.msg}`)
    }
    setTimeout(() => {
      visiblemodal()
    }, 1000)
  }
  return {
    dataSource,
    visible,
    pages,
    role,
    onSearch,
    onChange,
    onRefresh,
    deleteuser,
    visiblemodal,
    onChangeCheck,
    onChangeRole,
    addMember,
    moveAdmin,
    confirmMoveAdmin,
    rolevisible,
    rolevisiblemodal,
  }
}

export default useAccountHook
import { useReducer, useEffect } from 'react'
import { detailProps } from './components/accountdetail'
import { AnyAction } from 'redux'
import { getSupplierId, getUserId, resetObj } from '../../tools/util'
import { history } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import { setModuleDataAction } from '../../modules/pagecache'
import {
  GET_EMPUSERLIST,
  DEL_USER,
  ADMIN_TRANSFER,
} from '../../api/System_Api'
import { userRouter } from '../../route'
import { CustomerConfirm } from '../../components/ModalUser'

// action 类型定义
const ACCOUNT_ACTION_TYPE = {
  GET_DATA: 'ACCOUNT/GET_Data', // 获取数据
  SET_DATA: 'ACCOUNT/SET_Data', // 设置数据
  SET_ROLE: 'ACCOUNT/SET_Role', // 设置角色数据
  SEARCH_DATA: 'ACCOUNT/Search_Data', // 搜索数据
  CHANGE_PAGES: 'ACCOUNT/Change_Pages', // 分页
  LOADING: 'ACCOUNT/Loading', // loading
  SET_DETAILDATA: 'ACCOUNT/SET_Detail_Data', // 设置详情
  SET_ENABLE: 'ACCOUNT/SET_Enable', // 禁启用账号
  VISIBLE: 'ACCOUNT/SET_Visible', // 弹窗显示隐藏
  ROLE_VISIBLE: 'ACCOUNT/SET_Role_Visible', // role 弹窗显示隐藏
  ADD_VISIBLE: 'ACCOUNT/SET_Add_Visible', // 新增弹窗显示隐藏
  CHANGE_USERID: 'ACCOUNT/Change_Userid', //
  CHANGE_DATA: 'ACCOUNT/CHANGE_DATA', // 替换所有状态
  SET_CHEACKDATA: 'ACCOUNT/SET_CHEACKDATA',
  CHANGE_ROLE: 'ACCOUNT/Change_Role', // 选择角色
  IS_UPDATE: 'ACCOUNT/IS_UPDATE', // 跳转新增或编辑页面
  SET_EMP: 'ACCOUNT/SET_EMP',
}
// 当前状态接口
interface AccountState {
  dataSource: { data: any[]; total: number; loading: boolean }
  detaildata: detailProps
  visible: boolean // 弹窗
  rolevisible: boolean // role弹窗
  addvisible: boolean // 新增角色弹窗
  searchdata: any
  pages: {
    pageNo: number
    pagesize: number
  }
  checkData: {
    key: any[]
    data: any[]
  }
  selectUserId: string //  选中的userid
  roleList: any[]
  role: any
  isUpdate: boolean
  empId: string
}
// 默认数据
const defaultState: AccountState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 员工账号详情数据
  detaildata: {
    name: '', // 姓名
    moblie: '', // 手机号码
    code: '', // 员工编号
    job: '', // 岗位
    organization: '', // 所属组织
    department: '', // 所属部门
    role: '', // 授权角色
  },
  // 初始化弹窗
  visible: false,
  rolevisible: false,
  addvisible: false,
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pagesize: 30,
  },
  checkData: {
    key: [],
    data: [],
  },
  selectUserId: '',
  roleList: [],
  role: {},
  isUpdate: false,
  empId: '',
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case ACCOUNT_ACTION_TYPE.GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pagesize = 30
      arr.searchdata = resetObj(arr.searchdata)
      return arr
    case ACCOUNT_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case ACCOUNT_ACTION_TYPE.SET_DETAILDATA:
      arr.detaildata = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.VISIBLE:
      arr.visible = !arr.visible
      return arr
    case ACCOUNT_ACTION_TYPE.SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_PAGES:
      arr.pages = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.LOADING:
      arr.dataSource.loading = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_USERID:
      arr.selectUserId = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.ROLE_VISIBLE:
      arr.rolevisible = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.ADD_VISIBLE:
      arr.addvisible = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_CHEACKDATA:
      arr.checkData.data = action.value.data
      arr.checkData.key = action.value.key
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_ROLE:
      arr.role = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_ROLE:
      arr.roleList = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.IS_UPDATE:
      arr.isUpdate = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.SET_EMP:
      arr.empId = action.value
      return arr
    case ACCOUNT_ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: ACCOUNT_ACTION_TYPE.SET_DATA,
  value: param,
})
// 弹窗显示隐藏
const changevisibleAction = () => ({
  type: ACCOUNT_ACTION_TYPE.VISIBLE,
})

// role弹窗显示隐藏
const changerolevisibleAction = (param: boolean) => ({
  type: ACCOUNT_ACTION_TYPE.ROLE_VISIBLE,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pagesize?: number }) => ({
  type: ACCOUNT_ACTION_TYPE.CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: ACCOUNT_ACTION_TYPE.LOADING,
  value: param,
})

const changeroleAction = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.CHANGE_ROLE,
  value: param,
})
// 设置批量的值
const setCheackData = (param: any) => ({
  type: ACCOUNT_ACTION_TYPE.SET_CHEACKDATA,
  value: param,
})

const useAccountHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, visible, pages, rolevisible, checkData, role } = state
  const supRoute = userRouter[1].url

  const dispatchredux = useDispatch()
  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取列表数据
  const getdata = async (accountState: AccountState) => {
    // 在saga处理中 获取state
    const params = { ...accountState.pages, ...accountState.searchdata }
    // 添加loading
    dispatch(changeloadingAction(true))
    const data = await GET_EMPUSERLIST({
      pageNo: params.pageNo,
      pageSize: params.pagesize,
      supplierId: getSupplierId(),
      name: params.realName,
      mail: params.mail,
      mobile: params.mobile,
      schemeId: params.schemeId,
    })
    if (data.code === 0) {
      const resdata = data.data.content
      const count = data.data.totalCount
      const action = setdataAction({
        dataSource: { data: resdata, total: count, loading: false },
        pageNo: data.data.pageNo,
      })
      dispatch(action)
    }
  }

  // 搜索
  const onSearch = (params: any) => {
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 分页
  const onChange = (pageNo: number, pagesize?: number) => {
    const action = changepageAction({
      pageNo: pageNo,
    })
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pagesize: pagesize ? pagesize : 30,
        },
      },
    })
  }

  // 关闭显示弹窗
  const visiblemodal = () => {
    const action = changevisibleAction()
    dispatch(action)
  }

  // 删除用户
  const deleteuser = () => {
    if (checkData.key.length === 0) {
      message.warning('请先勾选数据，再提交')
      return
    }
    CustomerConfirm({
      title: '提示',
      content: '确认删除？',
      onOk: () => postDeleteUser(),
    })
  }

  const postDeleteUser = async () => {
    message.loading('删除账号中', 0)
    const userList = checkData.key
    const data = await DEL_USER({
      params: userList,
    })
    if (data.code === 0) {
      message.success('删除成功')
      getdata(state)
    }
  }
  const rolevisiblemodal = () => {
    dispatch(changerolevisibleAction(false))
  }

  // 勾选数据
  const onChangeCheck = (key: any, info: any) => {
    const action = setCheackData({ data: info, key: key })
    dispatch(action)
  }

  // 选择角色
  const onChangeRole = (key: any) => {
    dispatch(changeroleAction(key))
  }

  // 跳转新增页面
  const addMember = () => {
    history.push({
      pathname: supRoute + '/accoutadd',
    })
  }

  // 移交管理员
  const moveAdmin = async () => {
    if (checkData.key.length === 0) {
      message.warn('请先勾选账号')
      return
    }
    if (checkData.key.length > 1) {
      // message.warn(`请先勾选一个账号`);
      dispatch(changerolevisibleAction(true))
      return
    }
    visiblemodal()
  }
  // 确认移交管理员
  const confirmMoveAdmin = async () => {
    const data = await ADMIN_TRANSFER({
      id: checkData.key.join(),
      supplierUserId: getUserId(),
    })
    if (data.code === 0) {
      message.success('操作成功!')
      getdata(state)
    } else {
      message.warning(`${data.msg}`)
    }
    setTimeout(() => {
      visiblemodal()
    }, 1000)
  }
  return {
    dataSource,
    visible,
    pages,
    role,
    onSearch,
    onChange,
    onRefresh,
    deleteuser,
    visiblemodal,
    onChangeCheck,
    onChangeRole,
    addMember,
    moveAdmin,
    confirmMoveAdmin,
    rolevisible,
    rolevisiblemodal,
  }
}

export default useAccountHook
